<template>
  <div>

    <div class="container-fluid">
      <div class="row ">
        <div class="col-12 p-0">
          <div class="login-card">
            <div style="margin-bottom: 150px;">
              <div>
                <a class="logo">
                  <img class="img-fluid for-light" src="../assets/images/logo/logo_tmkt3.png" alt="looginpage" style="width: 300px;" />
                  <img class="img-fluid for-dark" src="../assets/images/logo/logo_tmkt3.png" alt="looginpage" />
                </a>
              </div>
              <div class="login-main">
                <form class="theme-form">
                  <div class="form-group">
                    <label class="col-form-label">Usuario</label>
                    <input :class="'form-control'+(submitted ? !user.email.value ? ' is-invalid' : ' is-valid' : '')" type="email" required=""  placeholder="" v-model="user.email.value">
                    <span class="validate-error invalid-feedback" v-if="!user.email.value || !validEmail(user.email.value)">{{ user.email.errormsg }}</span>

                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Contraseña</label>
                    <div class="form-input position-relative">
                      <input :class="'form-control '+(submitted ? !user.password.value ? ' is-invalid' : ' is-valid' : '')" :type="show_password ? 'text' : 'password'" name="login[password]" required=""placeholder v-model="user.password.value">
                      <span class="validate-error invalid-feedback" v-if="user.password.value.length < 7">{{ user.password.errormsg}}</span>

                      <div class="show-hide" @click="show_password = !show_password"><span :class="show_password ? 'hide' : 'show'"></span></div>
                    </div>
                  </div>
                  <div class="form-group mb-0">
                    <div class="text-end mt-3">
                      <button class="btn btn-primary btn-block w-100" type="submit" @click.prevent="login">Iniciar Sesión</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

import login from '../services/login';

export default {
  name: 'login',
  data() {
    return {
      show_password: false,
      submitted: false,
      result: { email: '', password: '' },

      user: {
        email: {
          value: '',
          errormsg: ''
        },
        password: {
          value: '',
          errormsg: ''
        }
      }
    };
  },

  created() {

  },

  methods: {

    async login() {
      this.submitted = true;
      if (!this.user.password.value) {
        this.user.password.errormsg = 'La contraseña es obligatoria.'
      } else { this.user.password.errormsg = '' }

      if (!this.user.email.value) {
        this.user.email.errormsg = 'El usuario es obligatorio.'
      } else {
        this.user.email.errormsg = ''
      }

      //Iniciar Sesión
      let params = {
        email: this.user.email.value,
        password: this.user.password.value,
        device_name: navigator.userAgent
      };

      let response = await login.login(params);

      if(response.type == "success"){
        let data = response.data;

        //Acceso solo para administradores
        if(!data.is_administrator){
          this.$toast.error("El acceso esta limitado solo para administradores.");
          return;
        }

        localStorage.setItem("token", data.access_token);
        localStorage.setItem("logged", JSON.stringify(data));

        axios.defaults.headers.common['access-token'] = data.access_token;
        axios.defaults.headers.common['api-token'] = data.access_token;

        localStorage.setItem('User', JSON.stringify({ email: this.user.email.value, useer: true }));

        window.location.href = "/"; return;
      }
      else{
        this.$toast.error(response.message);
      }
    },
    validEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  },
};
</script>
